import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
// @ts-ignore
import * as _ from 'lodash';
import { DropdownDictionary } from '@cupoui/shared/model/dropdownDictionary';

@Component({
    selector: 'app-multiple-select-dropdown',
    templateUrl: './multiple-select-dropdown.component.html',
    styleUrls: ['./multiple-select-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MultipleSelectDropdownComponent implements OnInit {
  @Input() name: string;
  @Input() placeholder: string;
  @Input() selectedItems: DropdownDictionary[];
  @Input() disabled: boolean;
  @Input() dropdownList = [];
  @Input() notSelectableList = [];

  @Output() selectedItemsChange = new EventEmitter();

  filteredlist = [];
  dropdownSettings = {};
  uniqueClassName: string;
  focused: boolean;

  constructor() {}

  ngOnInit() {
    this.filteredlist = _.cloneDeep(this.dropdownList);

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      limitSelection: 10,
      allowSearchFilter: true
    };
  }
  onItemSelect(item: any) {
    this.selectedItemsChange.emit(this.selectedItems);
  }
  onItemDeSelect(item: any) {
    this.selectedItemsChange.emit(this.selectedItems);
  }
}
